import {
  shape, string, number, bool,
} from 'prop-types';

export const responsibleUserInfoPropTypes = shape({
  id: number,
  type: string,
  username: string,
  avatarUrl: string,
});

export const currentUserInfoPropTypes = shape({
  id: number,
  type: string,
  username: string,
  avatarUrl: string,
  companyId: number,
  fullAdmin: bool,
});

export const selectedNodePropTypes = shape({
  id: number,
  title: string,
  status: string,
  priority: string,
  ticketType: string,
  assignee: shape({
    id: number,
    type: string,
    username: string,
    avatarUrl: string,
  }),
  responsibleUser: shape({
    id: number,
    type: string,
    username: string,
    avatarUrl: string,
  }),
  author: shape({
    id: number,
    type: string,
    username: string,
    avatarUrl: string,
  }),
  dueDate: string,
  description: string,
  cwoModule: string,
  createdAt: string,
  companyId: number,
  jiraLink: string,
});

export const responsibleUserInfoDefaultPropTypes = {
  id: null,
  type: '',
  username: '',
  avatarUrl: '',
};

export const currentUserInfoDefaultPropTypes = {
  id: null,
  type: '',
  username: '',
  avatarUrl: '',
  companyId: null,
  fullAdmin: false,
};

export const selectedNodeDefaultPropTypes = {
  id: null,
  title: '',
  status: '',
  priority: '',
  ticketType: '',
  assignee: {
    id: null,
    type: '',
    username: '',
    avatarUrl: '',
  },
  responsibleUser: {
    id: null,
    type: '',
    username: '',
    avatarUrl: '',
  },
  author: {
    id: null,
    type: '',
    username: '',
    avatarUrl: '',
  },
  dueDate: null,
  description: '',
  cwoModule: '',
  createdAt: '',
  companyId: null,
  jiraLink: '',
};
